import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { DashboardModules } from "src/core/enums/module-name-enums";
import isModuleAndActionAvailable from "src/core/guards/is-module-and-action-available";

const DashboardComponent = () => {
  const modules = useSelector((state: any) => state.navbar.modules);
  const [hasDashboardPermission, setHasDashboardPermission] = useState<
    boolean | null
  >(null);
  const [firstAccessiblePath, setFirstAccessiblePath] = useState<string | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!modules?.length) return;

    const checkPermission = async () => {
      setIsLoading(true);
      // Check dashboard permission
      const hasPerm = await isModuleAndActionAvailable(
        DashboardModules.DASHBOARD,
        "View-Dashboard",
        modules,
      );

      setHasDashboardPermission(hasPerm);

      // Find the first top‑level module the user can access
      let firstPath: string | null = null;
      for (const module of modules) {
        if (module?.hasPermission && module?.url) {
          firstPath = module?.url;
          break;
        }
      }

      setFirstAccessiblePath(firstPath);
      setIsLoading(false);
    };

    checkPermission();
  }, [modules]);

  useEffect(() => {
    if (isLoading) {
      document.body.classList.add("loading-indicator");
    } else {
      document.body.classList.remove("loading-indicator");
    }

    return () => {
      document.body.classList.remove("loading-indicator");
    };
  }, [isLoading]);

  if (isLoading) {
    return <div className="loading-spinner"></div>;
  }

  if (hasDashboardPermission) {
    return <Outlet />;
  }

  // No dashboard permission – redirect to the first accessible module
  if (firstAccessiblePath) {
    return <Navigate to={firstAccessiblePath} replace />;
  }

  // No accessible modules at all – show forbidden page
  return <Navigate to="/forbidden" replace />;
};

export default DashboardComponent;
